// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2JUug","range":"MonthRangeSwitch_range__3KQf1","disabled":"MonthRangeSwitch_disabled__2B5ne"};